import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './FlowLayout.css';
import './BookingPreference.css';

const CheckLight = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#0071BC" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="18" height="18" style={{ marginRight: '8px', flexShrink: 0 }}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const CheckBold = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="#2E8540" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="18" height="18" style={{ marginRight: '8px', flexShrink: 0 }}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

function BookingPreference() {
  const navigate = useNavigate();

  return (
    <div className="flow-page">
      <Helmet>
        <title>Get Started</title>
        <meta name="description" content="Choose between appointment notifications or automatic booking." />
      </Helmet>

      {/* Progress Bar — Step 1 */}
      <div className="progress-bar-container" role="progressbar" aria-valuenow={1} aria-valuemin={1} aria-valuemax={5} aria-label="Step 1 of 5: Choose Service">
        <div className="progress-bar-header">
          <button className="flow-back" onClick={() => navigate('/')}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
          <div className="progress-bar-label">Step 1: Choose Service</div>
        </div>
        <div className="progress-bar-track">
          <div className="progress-bar-fill" style={{ width: '20%' }} />
        </div>
      </div>

      <div className="booking-content" style={{ maxWidth: '1000px', margin: '0 auto', padding: '40px 20px' }}>
        <h1 className="booking-title" style={{ textAlign: 'center', marginBottom: '12px' }}>
          How would you like to get your appointment?
        </h1>
        <p className="booking-subtitle" style={{ textAlign: 'center', marginBottom: '48px', color: '#64748b' }}>
          Get notified when a slot opens or let us book it for you automatically.
        </p>

        <div className="booking-cards" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '24px' }}>
          {/* Notify Card */}
          <div className="booking-card" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div className="card-badge card-badge--notify">Basic</div>
            <h2 className="card-title">Notify</h2>
            <p className="card-description">We'll tell you when a slot opens.</p>
            <hr className="card-divider" />
            <div className="card-price">
              <span className="card-price-amount">$2</span>
              <span className="card-price-label">one time</span>
            </div>
            <p className="card-features-label">Features:</p>
            <ul className="card-features" style={{ listStyle: 'none', padding: 0, margin: '0 0 32px 0', flexGrow: 1 }}>
              <li className="card-feature" style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', fontSize: '0.95rem' }}><CheckLight />Choose up to 3 enrollment centers</li>
              <li className="card-feature" style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', fontSize: '0.95rem' }}><CheckLight />Email notifications when slots open</li>
              <li className="card-feature" style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', fontSize: '0.95rem' }}><CheckLight />Unsubscribe anytime</li>
            </ul>
            <button className="card-cta card-cta--secondary" onClick={() => { navigate('/notify'); window.scrollTo(0, 0); }}>
              Notify Me
            </button>
          </div>

          {/* Autobook Card */}
          <div className="booking-card booking-card--autobook" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div className="card-badge card-badge--autobook">✦ Most Popular</div>
            <h2 className="card-title">Autobook</h2>
            <p className="card-description">We'll book it for you automatically.</p>
            <hr className="card-divider" />
            <div className="card-price">
              <span className="card-price-amount">$25</span>
              <span className="card-price-label">one time</span>
            </div>
            <p className="card-features-label">Features:</p>
            <ul className="card-features" style={{ listStyle: 'none', padding: 0, margin: '0 0 32px 0', flexGrow: 1 }}>
              <li className="card-feature" style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', fontSize: '0.95rem' }}><CheckBold />Automatic interview booking</li>
              <li className="card-feature" style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', fontSize: '0.95rem' }}><CheckBold />Guaranteed within two weeks</li>
              <li className="card-feature" style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', fontSize: '0.95rem' }}><CheckBold />Set preferred dates and times</li>
              <li className="card-feature" style={{ display: 'flex', alignItems: 'center', marginBottom: '12px', fontSize: '0.95rem' }}><CheckBold />Confirmation email when booked</li>
            </ul>
            <button className="card-cta card-cta--primary" onClick={() => { navigate('/autobook'); window.scrollTo(0, 0); }}>
              Book it for Me
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingPreference;
